import React from 'react'

type IconName =
  | 'calendar' | 'building' | 'warehouse' | 'users' | 'megaphone' | 'alert'
  | 'stats' | 'tools' | 'help' | 'area' | 'body' | 'workflow' | 'sector'
  | 'machine' | 'briefcase' | 'search' | 'plus' | 'filter' | 'chevronDown'
  | 'chevronLeft' | 'chevronRight' | 'more' | 'close' | 'menu' | 'check'
  | 'xCircle' | 'clock' | 'bell' | 'note' | 'settings' | 'home' | 'list'
  | 'phone' | 'user' | 'logout' | 'message' | 'download' | 'gavel' | 'poll' | 'edit' | 'pen' | 'eye'

interface IconProps {
  name: IconName
  size?: number
  stroke?: number
  className?: string
  color?: string
}

const paths: Record<IconName, React.ReactNode> = {
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2.5"/><path d="M3 9h18M8 3v4M16 3v4"/></>,
  building: <><rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M10 21v-3h4v3"/></>,
  warehouse: <><path d="M3 21V9l9-5 9 5v12"/><path d="M7 21v-8h10v8"/><path d="M10 17h4"/></>,
  users: <><circle cx="9" cy="8" r="3.5"/><path d="M3 21c0-3.3 2.7-6 6-6s6 2.7 6 6"/><circle cx="17" cy="9" r="2.5"/><path d="M21 19c0-2.5-1.8-4-4-4"/></>,
  megaphone: <><path d="M3 11v3l9 4V7l-9 4zM14 8v9M17 11h3M18 14h2"/></>,
  alert: <><path d="M12 4l10 17H2L12 4z"/><path d="M12 10v5M12 18h.01"/></>,
  stats: <><rect x="3" y="13" width="4" height="8"/><rect x="10" y="8" width="4" height="13"/><rect x="17" y="4" width="4" height="17"/></>,
  tools: <><path d="M14 7l3-3 3 3-3 3M14 7l-5 5M7 14l-3 3 3 3 3-3M7 14l5-5M12 12l2 2"/></>,
  help: <><circle cx="12" cy="12" r="9"/><path d="M9.5 9c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5c0 1.5-2.5 1.5-2.5 4M12 17h.01"/></>,
  area: <><path d="M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z"/></>,
  body: <><circle cx="12" cy="5" r="2.5"/><path d="M8 22l1-8 3-2 3 2 1 8M9 14l-2-4M15 14l2-4"/></>,
  workflow: <><circle cx="5" cy="6" r="2"/><circle cx="19" cy="6" r="2"/><circle cx="12" cy="18" r="2"/><path d="M7 6h10M6 8l5 8M18 8l-5 8"/></>,
  sector: <><path d="M12 2L3 7v6c0 5 4 9 9 9s9-4 9-9V7l-9-5z"/></>,
  machine: <><rect x="3" y="10" width="18" height="10" rx="1.5"/><path d="M7 10V6h10v4M12 14v2"/></>,
  briefcase: <><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M3 13h18"/></>,
  search: <><circle cx="11" cy="11" r="7"/><path d="M20 20l-4.5-4.5"/></>,
  plus: <><path d="M12 5v14M5 12h14"/></>,
  filter: <><path d="M3 5h18l-7 9v6l-4-2v-4L3 5z"/></>,
  chevronDown: <><path d="M6 9l6 6 6-6"/></>,
  chevronLeft: <><path d="M15 18l-6-6 6-6"/></>,
  chevronRight: <><path d="M9 6l6 6-6 6"/></>,
  more: <><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></>,
  close: <><path d="M6 6l12 12M18 6L6 18"/></>,
  menu: <><path d="M3 6h18M3 12h18M3 18h18"/></>,
  check: <><path d="M5 12l5 5L20 7"/></>,
  xCircle: <><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  bell: <><path d="M6 8a6 6 0 0 1 12 0c0 7 3 7 3 9H3c0-2 3-2 3-9z"/><path d="M10 21a2 2 0 0 0 4 0"/></>,
  note: <><path d="M5 3h9l5 5v13H5z"/><path d="M14 3v5h5M9 13h6M9 17h4"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/></>,
  home: <><path d="M4 10l8-7 8 7v10H4z"/></>,
  list: <><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></>,
  phone: <><path d="M22 17v3a2 2 0 0 1-2 2A17 17 0 0 1 3 5a2 2 0 0 1 2-2h3a1 1 0 0 1 1 1l1 4-3 2a12 12 0 0 0 6 6l2-3 4 1a1 1 0 0 1 1 1z"/></>,
  user: <><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-6 8-6s8 2 8 6"/></>,
  logout: <><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/></>,
  message: <><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></>,
  download: <><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></>,
  gavel: <><path d="M14 3l7 7-1.5 1.5-7-7L14 3z"/><path d="M5 12l7 7-1.5 1.5-7-7L5 12z"/><path d="M3 21l4-4"/><path d="M10 10l4 4"/></>,
  poll: <><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></>,
  edit: <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></>,
  pen: <><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></>,
  eye: <><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></>,
}

export default function Icon({ name, size = 18, stroke = 1.75, className, color }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={color ? { color } : undefined}
    >
      {paths[name]}
    </svg>
  )
}
